import * as React from 'react';
import { createLocators } from '@u1/locators';
import clsx from 'clsx';
import useStyles from './Toggle.styles';

export interface IToggleProps {
  /**
   * The name of the input element.
   */
  name?: string;
  /**
   * Toggle value
   */
  value?: string | number | string[];
  /**
   * Triggers checked state
   */
  checked?: boolean;
  /**
   * Triggers disabled state
   */
  disabled?: boolean;
  /**
   * HTML input onChange callback. 'value' and 'checked' could be extracted from the event target. {value, checked} = e.target
   */
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => unknown;
  /**
   * React ref for toggle input
   */
  inputRef?: React.Ref<HTMLLabelElement>;
}

export const toggleLocators = createLocators({
  name: 'Toggle',
  componentLocators: ['label', 'input', 'knob'],
});
const { locators } = toggleLocators();

const Toggle: React.FC<IToggleProps> = ({
  name,
  checked,
  value,
  disabled,
  onChange,
  inputRef,
}) => {
  const classes = useStyles();

  return (
    <label
      {...locators.label()}
      ref={inputRef}
      tabIndex={0}
      className={clsx({
        [classes.root]: true,
        [classes.checked]: checked,
        [classes.disabled]: disabled,
      })}
    >
      <input
        {...locators.input()}
        type="checkbox"
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
        className={classes.input}
      />
      <div {...locators.knob()} className={classes.knob} />
    </label>
  );
};

export default Toggle;
